/**
 * @file Identities Master View.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { renderRoutes } from 'react-router-config';
import Helmet from 'react-helmet';

const propTypes = {
  route: PropTypes.object,
};

const IdentitiesMasterView = ({ route }) => {
  return (
    <Fragment>
      <Helmet>
        <title>My identities &ndash; Waldo</title>
      </Helmet>

      {renderRoutes(route.routes)}
    </Fragment>
  );
};

IdentitiesMasterView.propTypes = propTypes;

export default IdentitiesMasterView;
